import React, { useState, useMemo } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';
import {
  FileText, Users, Briefcase, GraduationCap, Building2,
  Download, ExternalLink, FileSignature, BookOpen, Search,
  Copy, CheckCircle2, Filter, X, File, FileText as FileDoc,
  FileSpreadsheet, Loader2
} from 'lucide-react';

const AcademicStaff = () => {
  const { t } = useTranslation();
  const categories = [
    {
      title: t('academicStaffDocuments.category1.title'),
      icon: <GraduationCap className="w-5 h-5" />,
      color: 'blue',
      documents: [
        {
          title: t('academicStaffDocuments.category1.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/%C3%96%C4%9Fretim%20%C3%9Cyesi%20Atamalar%C4%B1nda%20Yurt%20D%C4%B1%C5%9F%C4%B1%20Deneyim%20%C5%9Eart%C4%B1%20G%C3%B6revlendirme%20Ba%C5%9Fvuru%20Formu.docx'
        },
        {
          title: t('academicStaffDocuments.category1.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/%C3%96%C4%9Fretim%20%C3%9Cyesi%20Atamalar%C4%B1nda%20Yurt%20D%C4%B1%C5%9F%C4%B1%20Deneyim%20%C5%9Eart%C4%B1%20G%C3%B6revlendirme%20Final%20Raporu.docx'
        },
        {
          title: t('academicStaffDocuments.category1.doc3'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/%C3%96%C4%9Fretim%20%C3%9Cyesi%20Atamalar%C4%B1nda%20Yurt%20D%C4%B1%C5%9F%C4%B1%20Deneyim%20%C5%9Eart%C4%B1%20%20%C3%9Cniversite%20YKK.pdf'
        }
      ]
    },
    {
      title: t('academicStaffDocuments.category2.title'),
      icon: <Briefcase className="w-5 h-5" />,
      color: 'green',
      documents: [
        {
          title: t('academicStaffDocuments.category2.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/G%C3%B6revlendirilmesi%20Teklif%20Edilen%20%C3%96%C4%9Fretim%20Eleman%C4%B1na%20%C4%B0li%C5%9Fkin%20G%C3%B6revlendirme%20Tablosu%20Formu.xlsx'
        },
        {
          title: t('academicStaffDocuments.category2.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/39.Madde%20K%C4%B1sa%20S%C3%BCreli%20Yurti%C3%A7i-Yurtd%C4%B1%C5%9F%C4%B1%20Ge%C3%A7ici%20G%C3%B6revlendirme%20Dilek%C3%A7esi.doc'
        },
        {
          title: t('academicStaffDocuments.category2.doc3'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/27-Yurtd%C4%B1%C5%9F%C4%B1%20Etkinliklerine%20Kat%C4%B1l%C4%B1m%20Formu.docx'
        },
        {
          title: t('academicStaffDocuments.category2.doc4'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/Yurti%C3%A7i%20Etkinliklere%20Kat%C4%B1l%C4%B1m%20Formu..docx'
        },
        {
          title: t('academicStaffDocuments.category2.doc5'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/23-39.%20MaddeYurd%C4%B1%C5%9F%C4%B1%20Bilgi%20Formu.doc'
        },
        {
          title: t('academicStaffDocuments.category2.doc6'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/29-Uzun%20S%C3%BCreli%20Yurti%C3%A7i%20G%C3%B6revlendirme%20Formu.doc'
        },
        {
          title: t('academicStaffDocuments.category2.doc7'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/Kamu%20Personel%20Bilgi%20Sistemi%20Formu.xlsx'
        },
        {
          title: t('academicStaffDocuments.category2.doc8'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/D%C3%B6n%C3%BC%C5%9F%20Raporu%20%20Bildirim%20Formu.docx'
        },
        {
          title: t('academicStaffDocuments.category2.doc9'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/38maddeyegoregorevlendirilecekogretimelemanlaricin%20(2).docx'
        }

      ]
    },
    {
      title: t('academicStaffDocuments.category3.title'),
      icon: <Building2 className="w-5 h-5" />,
      color: 'purple',
      documents: [
        {
          title: t('academicStaffDocuments.category3.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/5-%C3%96%C4%9Fretim%20%C3%9Cyelerinin%20Di%C4%9Fer%20Y%C3%BCksek%C3%B6%C4%9Fretim%20Kurumlar%C4%B1nda%20G%C3%B6revlendirilme%20Formu.docx'
        },
        {
          title: t('academicStaffDocuments.category3.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/fotogaleri/serap%20%C5%9Fenel/%C3%96%C4%9Fretim%20%C3%9Cyelerinin%20Di%C4%9Fer%20Y%C3%BCksek%C3%B6%C4%9Fretim%20Kurumlar%C4%B1nda%20G%C3%B6revlendirmelerine%20%C4%B0li%C5%9Fkin%20Usul%20ve%20Esaslar.pdf'
        },
        {
          title: t('academicStaffDocuments.category3.doc3'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/duyurular/Personel/Birim%20Ders%20Y%C3%BCk%C3%BC%20Bilgi%20Tablosu.docx'
        }
      ]
    }
  ];

  const otherCategories = [
    {
      title: t('academicStaffDocuments.category4.title'),
      icon: <Building2 className="w-5 h-5" />,
      color: 'indigo',
      documents: [
        {
          title: t('academicStaffDocuments.category4.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/32-Teknokent%20G%C3%B6revlendirme%20Y%C3%B6nergesi.pdf'
        },
        {
          title: t('academicStaffDocuments.category4.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/33-Teknokent%20G%C3%B6revlendirmelerinde%20Yap%C4%B1lacak%20%C4%B0%C5%9Flemler.pdf'
        },
        {
          title: t('academicStaffDocuments.category4.doc3'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/18-05-22%20Teknokent%20Yar%C4%B1%20Zamanl%C4%B1%20Olarak%20%C3%87al%C4%B1%C5%9Fmak%20%C3%9Czere%20G%C3%B6revlendirme%20Talep%20Formu.doc'
        },
        {
          title: t('academicStaffDocuments.category4.doc4'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/2-%C3%96%C4%9Fretim%20Elemanlar%C4%B1%20TeknokentTam%20Zamanl%C4%B1%20G%C3%B6revlendirme%20Talep%20Formu.docx'
        },
        {
          title: t('academicStaffDocuments.category4.doc5'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/3-%C4%B0dari%20Personel%20Teknokent%20G%C3%B6revlendirme%20Talep%20Formu.docx'
        },
        {
          title: t('academicStaffDocuments.category4.doc6'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/%C5%9Firket%20kurma.doc'
        }
      ]
    },
    {
      title: t('academicStaffDocuments.category5.title'),
      icon: <Users className="w-5 h-5" />,
      color: 'rose',
      documents: [
        {
          title: t('academicStaffDocuments.category5.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/duyurular/Personel/Birim%20Ders%20Y%C3%BCk%C3%BC%20Bilgi%20Tablosu.docx'
        },
        {
          title: t('academicStaffDocuments.category5.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/duyurular/Formlar/Dr.%20Ar%C5%9F.%20G%C3%B6r.-Uyg.%20Alan%20%C3%96%C4%9Fr.%20G%C3%B6r.%20-Emekli%20%C3%96%C4%9Fr.%20Eleman%C4%B1%20Ders%20Verme%20Dilek%C3%A7e%20ve%20Formu.docx'
        }
      ]
    }
  ];

  const moreCategories = [
    {
      title: t('academicStaffDocuments.category6.title'),
      icon: <BookOpen className="w-5 h-5" />,
      color: 'amber',
      documents: [
        {
          title: t('academicStaffDocuments.category6.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/Hacettepe%20%C3%9Cniversitesi%20Yay%C4%B1n%20Y%C3%B6nergesi.pdf'
        },
        {
          title: t('academicStaffDocuments.category6.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/26-Yay%C4%B1n%20De%C4%9Ferlendirme%20Formu.pdf'
        },
        {
          title: t('academicStaffDocuments.category6.doc3'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/basili_dijital_yayin%20formu.pdf'
        },
        {
          title: t('academicStaffDocuments.category6.doc4'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/Yay%C4%B1n%202024/EK5.docx'
        },
        {
          title: t('academicStaffDocuments.category6.doc5'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/Yay%C4%B1n%202024/EK1.docx'
        },
        {
          title: t('academicStaffDocuments.category6.doc6'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/Yay%C4%B1n%202024/EK2.docx'
        },
        {
          title: t('academicStaffDocuments.category6.doc7'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/Yay%C4%B1n%202024/EK3.docx'
        },
        {
          title: t('academicStaffDocuments.category6.doc8'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/Yay%C4%B1n%202024/EK4.docx'
        }
      ]
    },
    {
      title: t('academicStaffDocuments.category7.title'),
      icon: <FileSignature className="w-5 h-5" />,
      color: 'cyan',
      documents: [
        {
          title: t('academicStaffDocuments.category7.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/Y%C3%BCkleme%20Senedi%20ve%20Muteber%20%C4%B0mzal%C4%B1%20M%C3%BCteselsil%20Kefalet%20Senedi.pdf'
        },
        {
          title: t('academicStaffDocuments.category7.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/Y%C3%BCkleme%20Senedi%20ve%20Muteber%20%C4%B0mzal%C4%B1%20M%C3%BCteselsil%20Kefalet%20Senedi%20(%C3%96RNEK).pdf'
        }
      ]
    },
    {
      title: t('academicStaffDocuments.category8.title'),
      icon: <FileText className="w-5 h-5" />,
      color: 'slate',
      documents: [
        {
          title: t('academicStaffDocuments.category8.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/1-Ayl%C4%B1k%20Ek%20Ders%20Puantaj%20Formu.xls'
        },
        {
          title: t('academicStaffDocuments.category8.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/2-%C3%96%C4%9Fretim%20Elemanlar%C4%B1%20Ders%20Y%C3%BCk%C3%BC%20ve%20Di%C4%9Fer%20Faaliyetler%20Bilgi%20Formu.docx'
        },
        {
          title: t('academicStaffDocuments.category8.doc3'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/4-Yurti%C3%A7i-Yurtd%C4%B1%C5%9F%C4%B1%20Ge%C3%A7ici%20G%C3%B6rev%20Yollu%C4%9Fu%20Bildirimi.xlsx'
        },
        {
          title: t('academicStaffDocuments.category8.doc4'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/6-Banka%20Beyan%20Formu.doc'
        },
        {
          title: t('academicStaffDocuments.category8.doc5'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/7-Ayl%C4%B1k%20Ders%20Y%C3%BCk%C3%BC%20Da%C4%9F%C4%B1l%C4%B1m%20Formu.xls'
        },
        {
          title: t('academicStaffDocuments.category8.doc6'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/9-Aile%20Yard%C4%B1m%20Bildirim%20Formu.doc'
        },
        {
          title: t('academicStaffDocuments.category8.doc7'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/15-Mal%20Bildirim%20Formu.xls'
        },
        {
          title: t('academicStaffDocuments.category8.doc8'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/16-Akademik%20G%C3%B6rev%20%C4%B0%C3%A7in%20M%C3%BCracaat%20Formu.doc'
        },
        {
          title: t('academicStaffDocuments.category8.doc9'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/24-4l%C3%BCk%20Sistemdeki%20Notlar%C4%B1n%20100l%C3%BCk%20Sistemdeki%20Kar%C5%9F%C4%B1l%C4%B1klar%C4%B1.pdf'
        },
        {
          title: t('academicStaffDocuments.category8.doc10'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/36-%C3%96%C4%9Fretim%20Eleman%C4%B1%20Kadrolar%C4%B1na%20Ba%C5%9Fvuru%20Dilek%C3%A7esi.doc'
        },
        {
          title: t('academicStaffDocuments.category8.doc11'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/e-dosyalar/formlar/akademik%20ve%20idari%20personel/37-%C3%96%C4%9Fretim%20G%C3%B6revlisi%20De%C4%9Ferlendirme%20Formu.pdf'
        }
      ]
    },
    {
      title: t('academicStaffDocuments.category9.title'),
      icon: <FileSignature className="w-5 h-5" />,
      color: 'emerald',
      documents: [
        {
          title: t('academicStaffDocuments.category9.doc1'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/TUBITAK_Proje_Eimza_OnSiparis_v4.xlsx'
        },
        {
          title: t('academicStaffDocuments.category9.doc2'),
          link: 'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/formlar/Kurul_YK_Eimza_OnSiparis_v2.xlsx'
        },
        {
          title: t('academicStaffDocuments.category9.doc3'),
          link: 'https://bidb.hacettepe.edu.tr/eimza/'
        }
      ]
    }
  ];

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [copiedLink, setCopiedLink] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const allCategories = [...categories, ...otherCategories, ...moreCategories];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'bg-blue-500/90 text-blue-50 hover:bg-blue-600/90',
      green: 'bg-green-500/90 text-green-50 hover:bg-green-600/90',
      purple: 'bg-purple-500/90 text-purple-50 hover:bg-purple-600/90',
      indigo: 'bg-indigo-500/90 text-indigo-50 hover:bg-indigo-600/90',
      rose: 'bg-rose-500/90 text-rose-50 hover:bg-rose-600/90',
      amber: 'bg-amber-500/90 text-amber-50 hover:bg-amber-600/90',
      cyan: 'bg-cyan-500/90 text-cyan-50 hover:bg-cyan-600/90',
      slate: 'bg-slate-500/90 text-slate-50 hover:bg-slate-600/90',
      emerald: 'bg-emerald-500/90 text-emerald-50 hover:bg-emerald-600/90'
    };
    return colors[color] || colors.blue;
  };

  const getFileIcon = (link) => {
    if (link.endsWith('.pdf')) return <FileText className="w-5 h-5" />;
    if (link.endsWith('.doc') || link.endsWith('.docx')) return <FileDoc className="w-5 h-5" />;
    if (link.endsWith('.xls') || link.endsWith('.xlsx')) return <FileSpreadsheet className="w-5 h-5" />;
    return <File className="w-5 h-5" />;
  };

  const getFileType = (link) => {
    if (link.endsWith('.pdf')) return 'PDF';
    if (link.endsWith('.doc') || link.endsWith('.docx')) return 'WORD';
    if (link.endsWith('.xls') || link.endsWith('.xlsx')) return 'EXCEL';
    return 'BELGE';
  };

  const handleCopyLink = (link) => {
    navigator.clipboard.writeText(link);
    setCopiedLink(link);
    setTimeout(() => setCopiedLink(null), 2000);
  };

  const handleSearch = (value) => {
    setIsLoading(true);
    setSearchTerm(value);
    // Simulate loading state
    setTimeout(() => setIsLoading(false), 500);
  };

  const filteredCategories = useMemo(() => {
    const filtered = allCategories
      .map(category => ({
        ...category,
        documents: category.documents.filter(doc =>
          doc.title.toLowerCase().includes(searchTerm.toLowerCase())
        )
      }))
      .filter(category => category.documents.length > 0);

    if (selectedCategory === 'all') return filtered;
    return filtered.filter(category => category.title === selectedCategory);
  }, [searchTerm, selectedCategory, allCategories]);

  const uniqueCategories = useMemo(() => 
    ['all', ...new Set(allCategories.map(cat => cat.title))],
    [allCategories]
  );

  const totalDocuments = useMemo(() => 
    filteredCategories.reduce((sum, cat) => sum + cat.documents.length, 0),
    [filteredCategories]
  );

  const DocumentCard = ({ document }) => {
    const fileIcon = getFileIcon(document.link);
    const fileType = getFileType(document.link);

  return (
      <div className="group relative flex items-center p-3 hover:bg-gray-50 rounded-lg transition-all duration-200">
        <div className="flex-shrink-0 mr-3">
          {fileIcon}
        </div>
        <div className="flex-grow min-w-0">
          <div className="flex items-start gap-2">
            <span className="text-base text-gray-600 group-hover:text-gray-900">
              {document.title}
            </span>
            <span className="flex-shrink-0 px-2 py-0.5 text-xs font-medium bg-gray-100 text-gray-600 rounded">
              {fileType}
            </span>
          </div>
        </div>
        <div className="flex items-center gap-2 ml-3">
          <button
            onClick={(e) => {
              e.preventDefault();
              handleCopyLink(document.link);
            }}
            className="p-1.5 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-lg transition-colors"
            title={t('academicStaffPage.copyLink')}
          >
            {copiedLink === document.link ? (
              <CheckCircle2 className="w-5 h-5 text-green-500" />
            ) : (
              <Copy className="w-5 h-5" />
            )}
          </button>
          <a
            href={document.link}
            target="_blank"
            rel="noopener noreferrer"
            className="p-1.5 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-lg transition-colors"
            title={t('academicStaffPage.openDocument')}
          >
            <ExternalLink className="w-5 h-5" />
          </a>
        </div>
      </div>
    );
  };

  return (
    <PageTemplate
      title={t('academicStaffPage.title')}
      subtitle={t('academicStaffPage.subtitle')}
    >
      <div className="max-w-[1400px] mx-auto px-4 py-8">
        <div className="mb-8">
          {/* Arama ve Filtreleme */}
          <div className="flex flex-col lg:flex-row gap-4 items-start lg:items-center mb-6">
            <div className="relative flex-grow">
              <input
                type="text"
                placeholder={t('academicStaffPage.searchPlaceholder')}
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
                className="w-full px-4 py-3 pl-12 text-lg rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
              />
              <div className="absolute left-4 top-1/2 transform -translate-y-1/2">
                {isLoading ? (
                  <Loader2 className="w-6 h-6 text-gray-400 animate-spin" />
                ) : (
                  <Search className="w-6 h-6 text-gray-400" />
                )}
              </div>
              {searchTerm && (
                <button
                  onClick={() => handleSearch('')}
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 p-1 hover:bg-gray-100 rounded-full"
                >
                  <X className="w-5 h-5 text-gray-400" />
                </button>
              )}
            </div>
            
            <div className="relative group lg:min-w-[200px]">
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="w-full px-4 py-3 pr-10 text-base rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 appearance-none bg-white"
              >
                <option value="all">{t('academicStaffPage.allCategories')}</option>
                {uniqueCategories.slice(1).map((cat, idx) => (
                  <option key={idx} value={cat}>{cat}</option>
                ))}
              </select>
              <Filter className="w-5 h-5 text-gray-400 absolute right-4 top-1/2 transform -translate-y-1/2 pointer-events-none" />
            </div>
                          </div>

          {/* Sonuç Özeti */}
          <div className="flex items-center justify-between text-sm text-gray-500">
            <span>
              {totalDocuments} {t('academicStaffPage.documentsFound')}
              {searchTerm && ` "${searchTerm}" ${t('common.for')}`}
              {selectedCategory !== 'all' && ` ${selectedCategory} ${t('common.inCategory')}`}
                            </span>
            {(searchTerm || selectedCategory !== 'all') && (
              <button
                onClick={() => {
                  setSearchTerm('');
                  setSelectedCategory('all');
                }}
                className="text-blue-500 hover:text-blue-600"
              >
                {t('academicStaffPage.clearFilters')}
              </button>
            )}
                          </div>
                        </div>

        {/* Kategoriler Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {filteredCategories.map((category, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow duration-200"
            >
              <div className={`px-6 py-4 flex items-center justify-between ${getColorClasses(category.color)}`}>
                <div className="flex items-center space-x-4">
                  <div className="p-2 bg-white/10 rounded-lg">
                    {React.cloneElement(category.icon, { className: "w-6 h-6" })}
                    </div>
                  <h3 className="font-semibold text-lg tracking-tight">{category.title}</h3>
                </div>
                <span className="px-3 py-1 bg-white/20 rounded-full text-sm">
                  {category.documents.length} {t('academicStaffPage.document')}
                </span>
              </div>
              <div className="divide-y divide-gray-100">
                {category.documents.map((doc, docIndex) => (
                  <DocumentCard key={docIndex} document={doc} />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Boş Sonuç */}
        {filteredCategories.length === 0 && (
          <div className="text-center py-16 bg-white rounded-xl shadow-sm border border-gray-200">
            <div className="text-gray-400 mb-4">
              <Search className="w-16 h-16 mx-auto" />
            </div>
            <h3 className="text-xl font-medium text-gray-900 mb-2">{t('academicStaffPage.noResults')}</h3>
            <p className="text-gray-500 text-lg">
              {searchTerm
                ? `"${searchTerm}" ${t('academicStaffPage.noResultsFor')}`
                : t('academicStaffPage.noResultsDesc')
              }
            </p>
            <button
              onClick={() => {
                setSearchTerm('');
                setSelectedCategory('all');
              }}
              className="mt-4 text-blue-500 hover:text-blue-600"
            >
              {t('academicStaffPage.clearFilters')}
            </button>
          </div>
        )}
      </div>
    </PageTemplate>
  );
};

export default AcademicStaff; 